import { usePreserveSearchParamsNavigate } from "../../../hooks/usePreserveSearchParamsNavigate.ts";
import { BOARDS, WORKSPACES } from "../../../routes.ts";
import { useWorkspaceUuid } from "../../hooks/useWorkspaceUuid.ts";
import type { BoardWorkspace } from "../types.ts";
import { useBoardUuid } from "./useBoardUuid.ts";

export const useNavigateToWorkspace = () => {
  const navigate = usePreserveSearchParamsNavigate();
  const workspaceUuid = useWorkspaceUuid();
  const boardUuid = useBoardUuid();
  return ({ workspace }: { workspace: BoardWorkspace }) => {
    navigate(
      `${WORKSPACES}/${workspaceUuid}/${BOARDS}/${boardUuid}/${workspace}`,
    );
  };
};
